import { useState } from 'react'
//@ts-ignore
import { InfoIconOutline } from 'components/icons'
import SurchargeModal from 'components/surcharge-modal'

interface MerchandisingMessageProps {
  merchandisingMessage?: string
  surchargeModalPrompt: string | null
}

const MerchandisingMessage = ({
  merchandisingMessage,
  surchargeModalPrompt,
}: MerchandisingMessageProps) => {
  const [showSurchargeModal, setShowSurchargeModal] = useState(false)
  return (
    <div>
      {surchargeModalPrompt ? (
        <div className="small mtm">
          <span role="none" onClick={() => setShowSurchargeModal(true)}>
            {surchargeModalPrompt}
            <InfoIconOutline
              style={{ height: '13px', margin: '0 0 2px 2px' }}
            />
          </span>
          <SurchargeModal
            show={showSurchargeModal}
            onHide={() => setShowSurchargeModal(false)}
          />
        </div>
      ) : (
        <div className="small mtm">{merchandisingMessage}</div>
      )}
    </div>
  )
}

export default MerchandisingMessage
